import * as React from 'react';
import { RootStore, withInjectedRootStore } from 'providers';
import { Brands } from 'enums';
import { useTranslation } from 'react-i18next';
import { Footer as WixUiFooter } from '@wix/wix-ui-premium-purchase';
import { Text, TextButton } from '@wix/design-system';
import { FooterLink, FooterLinkCode } from './FooterLink';
// TODO - Consolidate all Brands enums (and others) into one repo and consume from there
import { Brands as PartialBrands } from '@wix/wix-ui-premium-purchase/dist/src/enums';

interface FooterProps {
  rootStore: RootStore;
}

const CopyrightText = ({ brand }) => {
  const { t } = useTranslation();
  return (
    <Text size='small' weight='normal' dataHook='copyright-text'>
      {t(
        brand === Brands.EDITOR_X
          ? 'footer.editorx.copyright'
          : 'footer.copyright',
      )}
    </Text>
  );
};

const BackToTopButtonLink = ({ scrollToTop }) => {
  const { t } = useTranslation();
  return (
    <TextButton
      size='small'
      skin='dark'
      onClick={scrollToTop}
      dataHook='footer-scroll'
    >
      {t('footer.back_to_top')}
    </TextButton>
  );
};

const FooterComp: React.FC<FooterProps> = ({ rootStore }) => {
  const {
    appContext: { brand },
    scrollToTop,
    isAnonymous,
  } = rootStore.appStore;
  const brandInFooter = brand === Brands.DAYFUL ? Brands.WIX : brand;
  return (
    <WixUiFooter
      brand={brandInFooter as PartialBrands}
      isLoggedIn={!isAnonymous}
      CopyrightText={() => <CopyrightText brand={brand} />}
      FirstButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.TERMS_OF_USE} />
      )}
      SecondButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.PRIVACY} />
      )}
      ThirdButtonLink={() => (
        <FooterLink brand={brand} code={FooterLinkCode.CONTACT_US} />
      )}
      BackToTopButtonLink={() => (
        <BackToTopButtonLink scrollToTop={scrollToTop} />
      )}
    />
  );
};

export const Footer = withInjectedRootStore(FooterComp);
